
import {Vue, Component} from 'vue-property-decorator';
import {dictApi, dictInstrumentApi, roleApi, userApi} from "@/api/organization";
import baseUrl, {imageUrl} from '@/constants';
import {integrityApi} from "@/api/integrity";

@Component({})
export default class OrderAudit extends Vue {
  private orgData = {} as any; //

  baseUrl = baseUrl

  mounted() {
    this.getData();
  }

  getData() {
    const id = this.$route.query.id;
    integrityApi.get({
      id: id
    }).then(r => {
      if (r.data.result === 0) {
        this.orgData = r.data.data;
      }
    })
  }

  downloadPdf() {
    window.open(baseUrl + "/file/download?file=" + this.orgData.promiseCreateUrl + "&name=" + this.orgData.orgName + "公示承诺书.pdf", '_blank');
  }
}
